const POLICY_ERROR_CODES = new Set([
  'GALLERY_EXPIRED',
  'PLAN_INACTIVE',
  'QUOTA_EXCEEDED',
]);

const readResponseData = (error) => error?.response?.data;

const readServerMessage = (data) => {
  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }
  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  return '';
};

export function getUploadErrorDetails(error) {
  const data = readResponseData(error);
  const status = error?.response?.status;
  const code = typeof data?.error === 'string' ? data.error : '';
  const reason = typeof data?.reason === 'string' ? data.reason : '';
  const quotaType = data?.quota?.type;

  if (code === 'QUOTA_UNAVAILABLE' && reason === 'no-plan') {
    return {
      code,
      reason,
      policyBlocked: true,
      retryable: false,
      message: 'Uploads will be available after the gallery owner activates a plan.',
    };
  }

  if (code === 'QUOTA_EXCEEDED') {
    const quotaLabel = quotaType === 'videoCount'
      ? 'video'
      : quotaType === 'photoCount'
        ? 'photo'
        : 'storage';
    return {
      code,
      reason,
      policyBlocked: true,
      retryable: false,
      message: `This gallery has reached its ${quotaLabel} upload limit. Please contact the gallery owner.`,
    };
  }

  if (code === 'PLAN_INACTIVE') {
    return {
      code,
      reason,
      policyBlocked: true,
      retryable: false,
      message: 'Uploads are unavailable because this gallery’s plan is inactive. Please contact the gallery owner.',
    };
  }

  if (code === 'GALLERY_EXPIRED') {
    return {
      code,
      reason,
      policyBlocked: true,
      retryable: false,
      message: 'Uploads are unavailable because this gallery’s access period has ended.',
    };
  }

  if (
    status === 403 &&
    readServerMessage(data).toLowerCase().includes('gallery is not available')
  ) {
    return {
      code,
      reason,
      policyBlocked: true,
      retryable: false,
      message: 'Uploads are not currently available for this gallery. Please contact the gallery owner.',
    };
  }

  const serverMessage = readServerMessage(data);
  const fallbackMessage = error instanceof Error && error.message
    ? error.message
    : 'Upload failed';

  return {
    code,
    reason,
    policyBlocked: POLICY_ERROR_CODES.has(code),
    retryable: !POLICY_ERROR_CODES.has(code),
    message: serverMessage || fallbackMessage,
  };
}
